<app-merchant-details
  [identity]="identity"
  [merchant]="merchant"
  [merchants]="recentMerchants"
></app-merchant-details>

<form name="achFundForm" [formGroup]="achFundForm">
  <div class="card card-nc" *ngIf="canViewLinkedBankAccountInfo()">
    <div class="card-heading">
      <i class="fa fa-link"></i>
      <span class="cardHeaderHeading"> LINKED BANK ACCOUNT </span>
      <span *ngIf="canUpdateAchFunding()" class="pull-right save-card">
        <button type="submit" class="btn btn-nc" (click)="saveAchFunds()">
          SAVE
        </button>
      </span>
    </div>
    <div *ngIf="canUpdateAchFunding()" class="card-body labelCommon">
      <div *ngIf="loadingHistory || saving">
        <i class="fa fa-spinner fa-2x fa-pulse"></i>
      </div>
      <div *ngIf="!loadingHistory && !saving">
        <div class="row cardRowBackground">
          <div class="col-md-4">
            <label for="achAllowed" class="control-label"> ACH Allowed </label>
          </div>
          <div class="col-md-4">
            <label for="Status" class="control-label"> Status </label>
          </div>
          <div class="col-md-4">
            <label for="achDeclineCount" class="control-label">NSF Count</label>
          </div>
        </div>
        <div class="row cardRowBackground">
          <div class="form-group col-md-4">
            <div class="col-md-10">
              <select
                class="form-control input-sm"
                id="achAllowed"
                name="achAllowed"
                formControlName="achAllowed"
              >
                <option *ngFor="let ans of ['Y', 'N']" [ngValue]="ans">
                  {{ ans | yesNo }}
                </option>
              </select>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('achAllowed').valid &&
                  achFundForm.get('achAllowed').touched &&
                  achFundForm.get('achAllowed').errors['required']
                "
              >
                Required
              </span>
            </div>
          </div>
          <div class="form-group col-md-4">
            <div class="row">
              <div
                class="col-md-10"
              >
                <select
                  class="form-control input-sm"
                  id="status"
                  name="status"
                  formControlName="status"
                >
                  <option *ngFor="let ans of ['Y', 'N']" [ngValue]="ans">
                    {{ ans === 'Y' | activeInactive }}
                  </option>
                </select>
                <span
                  class="help-block has-error validationMessage"
                  *ngIf="
                    !achFundForm.get('status').valid &&
                    achFundForm.get('status').touched &&
                    achFundForm.get('status').errors['required']
                  "
                >
                  Required
                </span>
              </div>
              <div class="col-md-1"></div>
              <div
                [ngClass]="
                  replenishMethods?.isActive == 'Y'
                    ? 'circleGreen'
                    : 'circleRed'
                "
              ></div>
            </div>
          </div>
          <div class="form-group col-md-4">
            <div class="col-md-10">
              <select
                class="form-control input-sm"
                id="achDeclineCount"
                name="achDeclineCount"
                formControlName="achDeclineCount"
              >
                <option
                  value="{{ achDeclineCountNewOption }}"
                  *ngIf="achDeclineCountNewOption"
                >
                  {{ achDeclineCountNewOption }}
                </option>
                <option value="0">0</option>
                <option value="99">99</option>
              </select>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('achDeclineCount').valid &&
                  achFundForm.get('achDeclineCount').touched &&
                  achFundForm.get('achDeclineCount').errors['required']
                "
              >
                Required
              </span>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-2 columnBorder">
            <label for="srcAcctName" class="control-label"
              >Name on Account</label
            >
          </div>
          <div class="col-md-2 columnBorder">
            <label for="srcABANum" class="control-label">Routing Number</label>
          </div>
          <div class="col-md-2 columnBorder">
            <label for="srcAcctNum" class="control-label text-nowrap"
              >Bank Account Number</label
            >
          </div>
          <div class="col-md-2 columnBorder">
            <label for="srcAcctType" class="control-label">Account Type </label>
          </div>
          <div class="col-md-2">
            <label for="srcORGType" class="control-label">Banking Type </label>
          </div>
        </div>
        <div
          class="row"
          *ngIf="achFundingInfo?.customerAccount.achAllowed != 'N'"
        >
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12">
              <input
                type="text"
                class="form-control input-sm"
                id="srcAcctName"
                name="srcAcctName"
                formControlName="srcAcctName"
                maxlength="22"
              />
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('srcAcctName').valid &&
                  achFundForm.get('srcAcctName').touched &&
                  achFundForm.get('srcAcctName').errors['invalidName']
                "
              >
                Invalid Name
              </span>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('srcAcctName').valid &&
                  achFundForm.get('srcAcctName').touched &&
                  achFundForm.get('srcAcctName').errors['required']
                "
              >
                Required
              </span>
            </div>
          </div>
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12">
              <input
                type="text"
                class="form-control input-sm"
                id="srcABANum"
                name="srcABANum"
                formControlName="srcABANum"
              />
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('srcABANum').valid &&
                  achFundForm.get('srcABANum').touched &&
                  achFundForm.get('srcABANum').errors['invalidRouting']
                "
              >
                Invalid routing number
              </span>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('srcABANum').valid &&
                  achFundForm.get('srcABANum').touched &&
                  achFundForm.get('srcABANum').errors['maxlength']
                "
              >
                Routing Number can only be 9 characters
              </span>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('srcABANum').valid &&
                  achFundForm.get('srcABANum').touched &&
                  achFundForm.get('srcABANum').errors['required']
                "
              >
                Required
              </span>
            </div>
          </div>
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12">
              <input
                type="text"
                class="form-control input-sm"
                id="srcAcctNum"
                name="srcAcctNum"
                value=""
                formControlName="srcAcctNum"
                placeholder="{{ bankAccountNumberPlaceholder }}"
                maxlength="20"
              />
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('srcAcctNum').valid &&
                  achFundForm.get('srcAcctNum').touched &&
                  achFundForm.get('srcAcctNum').errors['invalidAcct']
                "
              >
                Account Number must be numeric
              </span>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('srcAcctNum').valid &&
                  achFundForm.get('srcAcctNum').touched &&
                  achFundForm.get('srcAcctNum').errors['maxlength']
                "
              >
                Length cannot exceed 16 digits
              </span>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('srcAcctNum').valid &&
                  achFundForm.get('srcAcctNum').touched &&
                  achFundForm.get('srcAcctNum').errors['required']
                "
              >
                Required
              </span>
            </div>
          </div>
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12">
              <select
                class="form-control input-sm"
                id="srcAcctType"
                name="srcAcctType"
                formControlName="srcAcctType"
              >
                <option value="C">Checking</option>
                <option value="S">Savings</option>
              </select>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('srcAcctType').valid &&
                  achFundForm.get('srcAcctType').touched &&
                  achFundForm.get('srcAcctType').errors['required']
                "
              >
                Required
              </span>
            </div>
          </div>
          <div class="form-group col-md-2">
            <div class="col-md-12">
              <select
                class="form-control input-sm"
                id="srcORGType"
                name="srcORGType"
                formControlName="srcORGType"
              >
                <option value="C">Consumer</option>
                <option value="B">Business</option>
              </select>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('srcORGType').valid &&
                  achFundForm.get('srcORGType').touched &&
                  achFundForm.get('srcORGType').errors['required']
                "
              >
                Required
              </span>
            </div>
          </div>
        </div>
        <div
          class="row"
          *ngIf="achFundingInfo?.customerAccount.achAllowed === 'N'"
        >
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12 staticText1">
              {{ replenishMethods.srcAcctName }}
            </div>
          </div>
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12 staticText1">
              {{ replenishMethods.srcABANum }}
            </div>
          </div>
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12 staticText1">
              {{ replenishMethods.srcAcctNum }}
            </div>
          </div>
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12 staticText1">
              {{ replenishMethods.srcAcctType | accountType }}
            </div>
          </div>
          <div class="form-group col-md-2">
            <div class="col-md-12 staticText1">
              {{ replenishMethods.srcORGType | bankingType }}
            </div>
          </div>
        </div>
        <div class="row" *ngIf="hasEntitlement('TODO_BANK_ADDRESS')">
          <div class="col-md-2 columnBorder">
            <label for="srcAcctName" class="control-label">Bank City</label>
          </div>
          <div class="col-md-2 columnBorder">
            <label for="srcABANum" class="control-label">Bank State</label>
          </div>
          <div class="col-md-2 columnBorder">
            <label for="srcAcctNum" class="control-label text-nowrap"
              >Bank Zip</label
            >
          </div>
        </div>
        <div
          class="row"
          *ngIf="
            achFundingInfo?.customerAccount.achAllowed != 'N' &&
            hasEntitlement('TODO_MERCHANT_BANK_ADDRESS')
          "
        >
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12">
              <input
                type="text"
                class="form-control input-sm"
                id="bankCity"
                name="bankCity"
                formControlName="bankCity"
              />
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('bankCity').valid &&
                  achFundForm.get('bankCity').touched &&
                  achFundForm.get('bankCity').errors['required']
                "
              >
                Required
              </span>
            </div>
          </div>
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12">
              <input
                type="text"
                class="form-control input-sm"
                id="bankState"
                name="bankState"
                formControlName="bankState"
              />
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('bankState').valid &&
                  achFundForm.get('bankState').touched &&
                  achFundForm.get('bankState').errors['required']
                "
              >
                Required
              </span>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('bankState').valid &&
                  achFundForm.get('bankState').touched &&
                  achFundForm.get('bankState').errors['invalidState']
                "
              >
                Two letter State
              </span>
            </div>
          </div>
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12">
              <input
                type="text"
                class="form-control input-sm"
                id="bankZip"
                name="bankZip"
                formControlName="bankZip"
              />
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('bankZip').valid &&
                  achFundForm.get('bankZip').touched &&
                  achFundForm.get('bankZip').errors['required']
                "
              >
                Required
              </span>
              <span
                class="help-block has-error validationMessage"
                *ngIf="
                  !achFundForm.get('bankZip').valid &&
                  achFundForm.get('bankZip').touched &&
                  achFundForm.get('bankZip').errors['invalidZip']
                "
              >
                Valid 6 digit zip
              </span>
            </div>
          </div>
        </div>
        <div
          class="row"
          *ngIf="achFundingInfo?.customerAccount.achAllowed == 'N'"
        >
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12 zeroPadding staticText1">
              {{ achfundingInfo?.bankAddress?.city }}
            </div>
          </div>
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12 zeroPadding staticText1">
              {{ achfundingInfo?.bankAddress?.state }}
            </div>
          </div>
          <div class="form-group col-md-2 columnBorder">
            <div class="col-md-12 zeroPadding staticText1">
              {{ achfundingInfo?.bankAddress?.zip }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card-body"
      *ngIf="canViewLinkedBankAccountInfo() && !canUpdateAchFunding()"
    >
      <div>
        <div *ngIf="loadingHistory || saving">
          <i class="fa fa-spinner fa-2x fa-pulse"></i>
        </div>
        <div *ngIf="!loadingHistory && !saving">
          <div class="row cardRowBackground labelCommon">
            <div class="col-md-4">
              <label for="achAllowed" class="control-label">
                ACH Allowed
              </label>
            </div>
            <div class="col-md-4">
              <label for="Status" class="control-label"> Status </label>
            </div>
            <div class="col-md-4">
              <label class="control-label">NSF Count</label>
            </div>
          </div>

          <div class="row cardRowBackground staticText1">
            <div class="col-md-4">
              <label for="achAllowed" class="control-label">
                {{ customerAccount?.achAllowed | yesNo }}
              </label>
            </div>
            <div class="col-md-4">
              <label for="Status" class="control-label">
                {{ replenishMethods?.isActive | yesNoStatus }}
              </label>
            </div>
            <div class="col-md-4">
              <label class="control-label">
                {{ customerAccount?.achDeclineCount }}
              </label>
            </div>
          </div>
          <br />
          <div class="row labelCommon">
            <div class="col-md-2 columnBorder">
              <label class="control-label">Name on Account</label>
            </div>
            <div class="col-md-2 columnBorder">
              <label class="control-label">Routing Number</label>
            </div>
            <div class="col-md-2 columnBorder">
              <label class="control-label text-nowrap"
                >Bank Account Number
              </label>
            </div>
            <div class="col-md-2 columnBorder">
              <label class="control-label">Account Type </label>
            </div>
            <div class="col-md-2">
              <label class="control-label">Banking Type </label>
            </div>
          </div>

          <div class="row staticText1">
            <div class="col-md-2 columnBorder">
              <label class="control-label">
                {{ replenishMethods?.srcAcctName }}
              </label>
            </div>
            <div class="col-md-2 columnBorder">
              <label class="control-label">
                {{ replenishMethods?.srcABANum }}
              </label>
            </div>
            <div class="col-md-2 columnBorder">
              <label class="control-label">
                {{ bankAccountNumberPlaceholder }}
              </label>
            </div>
            <div class="col-md-2 columnBorder">
              <label class="control-label">
                {{ replenishMethods?.srcAcctType | accountType }}
              </label>
            </div>
            <div class="col-md-2">
              <label class="control-label">
                {{ replenishMethods?.srcORGType | bankingType }}
              </label>
            </div>
          </div>
          <div
            class="row labelCommon"
            *ngIf="hasEntitlement('TODO_MERCHANT_BANK_ADDRESS')"
          >
            <div class="col-md-2 columnBorder">
              <label for="bankCity" class="control-label">Bank City </label>
            </div>
            <div class="col-md-2 columnBorder">
              <label for="bankState" class="control-label">Bank State</label>
            </div>
            <div class="col-md-2 columnBorder">
              <label for="bankZip" class="control-label text-nowrap"
                >Bank Zip</label
              >
            </div>
          </div>
          <div
            class="row staticText1"
            *ngIf="hasEntitlement('TODO_MERCHANT_BANK_ADDRESS')"
          >
            <div class="col-md-2 columnBorder">
              <label for="bankCity" class="control-label">{{
                bankAddress?.city
              }}</label>
            </div>
            <div class="col-md-2 columnBorder">
              <label for="bankState" class="control-label">{{
                bankAddress?.state
              }}</label>
            </div>
            <div class="col-md-2 columnBorder">
              <label for="bankZip" class="control-label">{{
                bankAddress?.zip
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<form name="fundRefundForm" #fndRefundForm="ngForm">
  <div
    class="card card-nc"
    *ngIf="
      hasEntitlement('MERCHANTS_ACHFUNDING_FUND_REFUND') &&
      achFundingInfo?.customerAccount.achAllowed === 'Y' &&
      achFundingInfo?.replenishMethods.isActive === 'Y'
    "
  >
    <div class="card-heading">
      <span class="icon-NC_history"></span>
      <span class="cardHeaderHeading"> ACH FUNDING/REFUND</span>
      <span class="pull-right save-card">
        <button
          type="submit"
          [ngClass]="transfer_ach_btn_spinner"
          class="btn btn-nc"
          (click)="achTransfer()"
          [disabled]="fundType === 'N' || fndRefundForm.invalid"
          #transferButton
        >
          TRANSFER
        </button>
      </span>
    </div>
    <div class="card-body">
      <div class="row labelCommon">
        <div class="col-md-4">
          <label for="fundType" class="col-md-12 control-label">
            To Request Funding/Refund
          </label>
          <div class="form-group col-md-10">
            <select
              class="form-control input-sm"
              id="fundType"
              name="fundType"
              [(ngModel)]="fundType"
            >
              <option
                *ngFor="let fundRefund of fundRefunds"
                [value]="fundRefund.id"
              >
                {{ fundRefund.value }}
              </option>
            </select>
          </div>
        </div>
        <div *ngIf="fundType !== 'N'" class="col-md-4">
          <label for="fundAmt" class="col-md-12 control-label"
            >Requesting Amount</label
          >
          <div class="form-group col-md-10">
            <input
              type="text"
              class="form-control input-sm"
              id="fundAmt"
              name="fundAmt"
              [(ngModel)]="fundAmt"
              placeholder="0.00"
              maxlength="9"
              required
              #fndAmt="ngModel"
              pattern="^([0-9]{1,6})+(\.[0-9]{1,2})?$"
              (blur)="focusTransferButton()"
            />
          </div>
          <div
            class="help-block has-error validationMessage"
            *ngIf="
              fndAmt.invalid &&
              fndAmt.touched
            "
          >
            <span
              *ngIf="
                fndAmt.errors.required
              "
            >
              Amount is mandatory when submitting an account funding request.
            </span>
            <span
              *ngIf="
                fndAmt.errors.pattern
              "
            >
              Amount should be more than $0.01 and less than $999999.99
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<form name="achHistory" [formGroup]="achHistoryForm">
  <div
    class="card card-nc"
    *ngIf="hasEntitlement('MERCHANTS_ACHFUNDING_HISTORY')"
  >
    <div class="card-heading">
      <div class="row">
        <div class="col-xs-4 col-md-4">
          <span class="icon-NC_history"></span>
          <span class="cardHeaderHeading"> ACH FUNDING HISTORY</span>
        </div>
        <div class="col-md-4 datepicker inline col-xs-4">
          <div class="row">
            <div class="col-xs-3 col-md-3 calHeading">Start Date</div>
            <div class="col-xs-8 col-md-8">
              <div class="input-group datepicker dtpicker-btn">
                <input
                  id="tranMinDate"
                  class="form-control"
                  formControlName="tranMinDate"
                  [maxDate]="endDate"
                  (dateSelect)="reloadAchHistory()"
                  (select)="reloadAchHistory()"
                  (change)="reloadAchHistory()"
                  ngbDatepicker
                  readonly="readonly"
                  (click)="d1.toggle()"
                  #d1="ngbDatepicker"
                />
                <div class="input-group-append">
                  <button
                    class="fa fa-calendar"
                    (click)="d1.toggle()"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 datepicker inline col-xs-4">
          <div class="row">
            <div class="col-xs-3 col-md-3 calHeading">End Date</div>
            <div class="col-xs-8 col-md-8">
              <div class="input-group datepicker dtpicker-btn">
                <input
                  id="tranMaxDate"
                  class="form-control"
                  formControlName="tranMaxDate"
                  (dateSelect)="reloadAchHistory()"
                  (select)="reloadAchHistory()"
                  (change)="reloadAchHistory()"
                  ngbDatepicker
                  [minDate]="startDate"
                  #d2="ngbDatepicker"
                  readonly="readonly"
                  (click)="d2.toggle()"
                />
                <div class="input-group-append">
                  <button
                    class="fa fa-calendar"
                    (click)="d2.toggle()"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table class="table tableBackground tableRow table-bordered table-hover">
      <thead class="transactionHistHeader tableheading">
        <tr>
          <th class="text-center">DATE</th>
          <th class="text-center">POSTED</th>
          <th class="text-center">ABA</th>
          <th class="text-center">ACCOUNT</th>
          <th class="text-center">STATUS</th>
          <th class="text-center">RETURN MESSAGE</th>
          <th class="text-center">AMOUNT</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngIf="!tableLoading && (achFunds === null || achFunds.length === 0)"
        >
          <td colspan="7" style="text-align: center; height: 150px;">
            No account activity found.
          </td>
        </tr>
        <tr *ngIf="tableLoading">
          <td colspan="7" style="text-align: center; height: 150px;">
            <i class="fa fa-spinner fa-2x fa-pulse"></i>
          </td>
        </tr>
        <tr *ngFor="let achFund of achFunds">
          <td class="transactionHistText text-center">
            {{ achFund.requestDate | date: 'mediumDate' }}
          </td>
          <td class="transactionHistText text-center">
            {{ achFund.postDate | date: 'mediumDate' }}
          </td>
          <td class="transactionHistText text-center">
            {{ achFund.bankAbaNumber }}
          </td>
          <td class="transactionHistText text-center">
            {{ achFund.bankAccountNumber }}
          </td>
          <td class="transactionHistText text-center">
            {{ achFund.statType }}
          </td>
          <td
            class="transactionHistText text-center"
            *ngIf="achFund.achReturnMessage"
          >
            {{ achFund.achReturnMessage }}, Ref# {{ achFund.transaction }}
          </td>
          <td
            class="transactionHistText text-center"
            *ngIf="!achFund.achReturnMessage"
          >
            Ref# {{ achFund.transaction }}
          </td>
          <td class="transactionHistText text-center">
            {{ achFund.amount | currency }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</form>
